import { GET_ALL_NOTIFICATION } from "../actions/types";

const initialState = {
  notificationList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },

  notificationLoading: true,
};

const notificationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_NOTIFICATION:
      return {
        ...state,
        notificationList: payload,
        notificationLoading: false,
      };

    default:
      return state;
  }
};
export default notificationReducer;
